// extracted by mini-css-extract-plugin
module.exports = {"apple-button":"AppleButton_apple-button__bvbk_"};